/**
 * What a list shows when it has no rows to render. A request that hasn't answered yet is not an
 * empty list, a failed one is not either, and a filtered miss says so (with a way out) instead of
 * claiming the container is empty.
 */
export type EmptyKind = "loading" | "error" | "filtered" | "empty";

export function emptyKind(s: { loaded: boolean; error: unknown; filtered: boolean }): EmptyKind {
  if (!s.loaded) return s.error ? "error" : "loading";
  return s.filtered ? "filtered" : "empty";
}
